import React from 'react'
import { Link } from 'react-router-dom';
import '../Styling Files/Navbar.css'

export default function Navbar() {
  return (
    <nav className="navbar navbar-expand-lg navbarComp">
    <div className="container-fluid">
        <Link className="navbar-brand navbarTitle" to="/">Jai Bhagwati Traders</Link>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
            <Link className="nav-link active" aria-current="page" to="/">Home</Link>
            </li>
            <li className="nav-item">
            <Link className="nav-link" to="/about">About Us</Link>
            </li>
            <li className="nav-item">
            <Link className="nav-link" to="/contact">Contact Us</Link>
            </li>
        </ul>
        </div>
    </div>
    </nav>
  )
}
//

